import api from "./api";

export function getAboutPage(country_id) {
  return api.get(`/homepage/${country_id}`);
}

export function createAboutPage(data) {
  return api.post("/homepage", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateAboutPage(country_id, data) {
  return api.put(`/about-page/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
